import type { PublicationCode } from '@/scopes/common/domain/models'
import { CatalogueType } from '@/config/types'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { AtLeastOne, SiteName } from '@/scopes/common/domain/types'

export function getPublicationCodeByCatalogueAndSiteName(catalogue: CatalogueType, siteName: SiteName): PublicationCode {
  const publicationCodes: Record<SiteName, AtLeastOne<Record<CatalogueType, PublicationCode>>> = {
    sunwebnl: { summer: PublicationCodes.PUBLICATION_CODES.SUNWEB_NL_SUMMER, winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_NL_WINTER },
    sunwebde: { winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_DE_WINTER },
    sunwebfr: { summer: PublicationCodes.PUBLICATION_CODES.SUNWEB_FR_SUMMER, winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_FR_WINTER },
    sunwebdk: { summer: PublicationCodes.PUBLICATION_CODES.SUNWEB_DK_SUMMER, winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_DK_WINTER },
    sunwebuk: { winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_UK_WINTER },
    sunwebse: { summer: PublicationCodes.PUBLICATION_CODES.SUNWEB_SE_SUMMER, winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_SE_WINTER },
    sunwebbenl: { summer: PublicationCodes.PUBLICATION_CODES.SUNWEB_BE_NL_SUMMER, winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_BE_NL_WINTER },
    sunwebbefr: { summer: PublicationCodes.PUBLICATION_CODES.SUNWEB_BE_FR_SUMMER, winter: PublicationCodes.PUBLICATION_CODES.SUNWEB_BE_FR_WINTER },
    elizanl: { summer: PublicationCodes.PUBLICATION_CODES.ELIZA_NL },
    elizabe: { summer: PublicationCodes.PUBLICATION_CODES.ELIZA_BE },
    elizauk: { summer: PublicationCodes.PUBLICATION_CODES.ELIZA_UK },
    gogonl: { summer: PublicationCodes.PUBLICATION_CODES.GOGO_NL },
  }

  const publicationCode = publicationCodes[siteName][catalogue]

  if (!publicationCode) {
    throw new Error(`No matching publication code for siteName: ${siteName} and catalogue: ${catalogue}`)
  }

  return publicationCode
}
